import CasBooleanIcon from '../../CasIcon/CasBooleanIcon';
import { ICasMRTCellProps } from './ICasMRTCellProps';

export function CasMRTCellRenderTrue({ cell }: ICasMRTCellProps) {
  const value = cell.getValue();
  return value !== null && <CasBooleanIcon value={!!value} falseIcon={false} />;
}

export function CasMRTCellRenderBoolTrueFalse({ cell }: ICasMRTCellProps) {
  const value = cell.getValue();
  return value !== null && <CasBooleanIcon value={value} falseIcon size={16} />;
}
